export default __webpack_public_path__ + "static/steel-29070d4137d0b511d4576c6d545da044.webm";